import { BottleBeer as o } from "./bottle-beer.js";
import { Beer as r } from "./beer.js";
import { Coffee2 as m } from "./coffee-2.js";
import { Drink as t } from "./drink.js";
import { Drinks as i } from "./drinks.js";
import { Bottle as f } from "./bottle.js";
import { Wine as p } from "./wine.js";
import { CocktailMojito as e } from "./cocktail-mojito.js";
import { Cocktail as a } from "./cocktail.js";
import { Food as n } from "./food.js";
import { Apple as l } from "./apple.js";
import { Salad as k } from "./salad.js";
import { Donut as c } from "./donut.js";
import { RiceBowl as d } from "./rice-bowl.js";
import { Watermelon as C } from "./watermelon.js";
import { Lemon as B } from "./lemon.js";
import { Pudding as D } from "./pudding.js";
import { IceCream as s } from "./ice-cream.js";
import { BirthdayCake as P } from "./birthday-cake.js";
import { Pizza as W } from "./pizza.js";
import { Qsr as u } from "./qsr.js";
import { CocktailGintonic as z } from "./cocktail-gintonic.js";
import { CocktailVodkalime as A } from "./cocktail-vodkalime.js";
import { Coffee as F } from "./coffee.js";
import { WatermelonPart as g } from "./watermelon-part.js";
const Y = {
  BottleBeer: o,
  Beer: r,
  Coffee2: m,
  Drink: t,
  Drinks: i,
  Bottle: f,
  Wine: p,
  CocktailMojito: e,
  Cocktail: a,
  Food: n,
  Apple: l,
  Salad: k,
  Donut: c,
  RiceBowl: d,
  Watermelon: C,
  Lemon: B,
  Pudding: D,
  IceCream: s,
  BirthdayCake: P,
  Pizza: W,
  Qsr: u,
  CocktailGintonic: z,
  CocktailVodkalime: A,
  Coffee: F,
  WatermelonPart: g
};
export {
  Y as FoodAndDrink
};
